import { createContext, useContext, useState } from "react";

const VideoUploadContext = createContext();

export const useVideoUpload = () => useContext(VideoUploadContext);

export const VideoUploadProvider = ({ children }) => {
  const [uploadStates, setUploadStates] = useState({});

  const updateUploadState = (identifier, state) => {
    setUploadStates((prev) => ({
      ...prev,
      [identifier]: { ...prev[identifier], ...state },
    }));
  };

  return (
    <VideoUploadContext.Provider value={{ uploadStates, updateUploadState }}>
      {children}
    </VideoUploadContext.Provider>
  );
};
